export default class ClerkHelper {
  constructor(labels = ['Clerk'], limit = 4) {
    this.limit = limit;
    this.labels = labels;
  }

  async getProducts(endpoint, settings = {}) {
    const query = {
      ...settings,
      ...{
        attributes: [
          'id',
          'name',
          'url',
          'handle',
          'description',
          'price',
          'image',
          'images',
          'tags',
          'variants',
          'variant_names',
          'variant_prices',
          'variant_stocks',
          'variant_list_prices',
        ],
      },
    };

    const response = await this.clerkFetch(endpoint, query);

    const products = response.product_data.map((item) => {
      const variantObject = [];

      for (let index = 0; index < item.variants.length; index += 1) {
        variantObject.push({
          id: item.variants[index],
          title: item.variant_names[index],
          price: item.variant_prices[index] ?? item.price,
          compare_at_price: item.variant_list_prices[index] ?? item.price,
          available: item.variant_stocks[index],
        });
      }

      const titleParts = item.name.split(' | ');
      const [, , gender] = titleParts;

      const imageAlt = item.images[1] ? {
        src: item.images[1].replace('160x160', '600x600'),
        width: 1500,
        height: 1500,
      } : null;

      return {
        ...item,
        ...{
          variants: variantObject,
          title: item.name,
          gender,
          image: {
            src: item.image.replace('160x160', '600x600'),
            width: 1500,
            height: 1500,
          },
          image_alt: imageAlt,
        },
      };
    });

    return {
      response,
      products,
    };
  }

  async getPages(endpoint, queryValue = '') {
    return this.clerkFetch(endpoint, {
      query: queryValue,
    });
  }

  async getCategories(endpoint, queryValue = '') {
    const { categories: response } = await this.clerkFetch(endpoint, {
      query: queryValue,
    });

    return response.filter((item) => !item.name.includes('linked'));
  }

  async clerkFetch(endpoint, settings) {
    const defaults = {
      key: window.theme.integrations.clerk,
      limit: this.limit,
      labels: this.labels,
    };

    return window.Clerk('call', endpoint, { ...defaults, ...settings });
  }
}
